"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AppConfig = require("./AppConfig");
Object.keys(_AppConfig).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppConfig[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AppConfig[key];
    }
  });
});
var _SocialMediaIcons = require("./SocialMediaIcons");
Object.keys(_SocialMediaIcons).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SocialMediaIcons[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SocialMediaIcons[key];
    }
  });
});
var _TranslationKey = require("./TranslationKey");
Object.keys(_TranslationKey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TranslationKey[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TranslationKey[key];
    }
  });
});